import { DeleteOutlined, EditFilled, PlusOutlined } from '@ant-design/icons';
import { Button, Modal, Switch, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import {
    fetchCountryRecords,
    insertCOuntryRecord,
    updateCountryRecord,
    deleteCountryRecord,
    changeCountryParameter,
} from '../../../redux/slice/country.slice';
import moment from 'moment';
import DebouncedSearch from '../../Common/DebouncedSearch';
import CommonTable from '../../Common/AdvancedTable';

const inputClass = `form-control
block
w-full
px-3
py-1.5
text-base
font-normal
text-gray-700
bg-white bg-clip-padding
border border-solid border-gray-300
rounded
transition
ease-in-out
m-0
focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none`;

export default function CountryMaster() {
    const Country = useSelector((state) => state.country);
    const dispatch = useDispatch();

    const [pagination, setPagination] = React.useState({
        pageNo: 0,
        limit: 15,
        count: 0,
        sortBy: 1,
        sortField: '_id',
        keywords: '',
    });

    useEffect(() => {
        setPagination({
            pageNo: Country.pageNo || 0,
            limit: Country.limit || 15,
            count: Country.count || 0,
            sortBy: Country.sortBy || 1,
            sortField: Country.sortField || '_id',
            keywords: Country.keywords || '',
        });
        fetchRecord({
            pageNo: Country.pageNo || 0,
            limit: Country.limit || 15,
            sortBy: Country.sortBy || 1,
            sortField: Country.sortField || '_id',
            keywords: Country.keywords || '',
        });
    }, []);

    useEffect(() => {
        setPagination((prev) => ({
            ...prev,
            count: Country.count || 0,
        }));
    }, [Country.count]);

    function fetchRecord({ pageNo, limit, sortBy, sortField, keywords }) {
        dispatch(fetchCountryRecords({ pageNo, limit, sortBy, sortField, keywords }));
    }

    const handleDeleteSlide = (id) => {
        dispatch(deleteCountryRecord({ id }));
        setTimeout(() => {
            fetchRecord(pagination);
        }, 100);
    };

    const handleSearch = (keywords) => {
        const updatedPagination = { ...pagination, pageNo: 0, keywords };
        setPagination(updatedPagination);
        dispatch(changeCountryParameter(updatedPagination));
        dispatch(fetchCountryRecords(updatedPagination));
    };

    const handleCountrySubmit = async (data, id, setOpen) => {
        try {
            if (id) {
                data._id = id;
                await dispatch(updateCountryRecord(data));
            } else {
                await dispatch(insertCOuntryRecord(data));
            }

            setTimeout(() => {
                dispatch(fetchCountryRecords(pagination));
            }, 100);
            setOpen(() => false);
        } catch (err) {
            alert(err.message);
        }
    };

    const handleStatusChange = async (checked, id) => {
        try {
            // var _slides = Country.records.map(s => {
            //     if(s._id == id) {
            //         s.status = checked;
            //     }
            //     return s;
            // })
            // setSlides(_slides);
        } catch (err) {
            alert(err.message);
        }
    };

    const onChangeTable = (paginate, filter, sorter, extra) => {
        const updatedSortField = sorter.field || '_id';
        const updatedSortBy = sorter.order === 'ascend' ? 1 : -1;

        const updatedPagination = {
            ...pagination,
            pageNo: paginate.current - 1,
            limit: paginate.pageSize,
            sortBy: updatedSortBy,
            sortField: updatedSortField,
            keywords: pagination.keywords,
        };

        setPagination(updatedPagination);
        dispatch(changeCountryParameter(updatedPagination));
        dispatch(fetchCountryRecords(updatedPagination));
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: 150,
            sorter: (a, b) => a.name?.localeCompare(b.name),
        },
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
            width: 150,
            sorter: (a, b) => a?.title?.localeCompare(b?.title),
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            width: 200,
            ellipsis: true,
            sorter: (a, b) => a?.description?.localeCompare(b?.description),
        },
        {
            title: 'Num Code',
            dataIndex: 'num_code',
            key: 'num_code',
            width: 120,
            sorter: (a, b) => a.num_code?.localeCompare(b.num_code),
        },
        {
            title: 'Str Code',
            dataIndex: 'str_code',
            key: 'str_code',
            width: 120,
            sorter: (a, b) => a.str_code?.localeCompare(b.str_code),
        },
        {
            title: 'Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 180,
            render: (e, record) => moment(e).format('lll'),
            sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
        },
        {
            title: 'Action',
            dataIndex: 'Action',
            key: 'Action',
            width: 150,
            fixed: 'right',
            render: (e, record) => (
                <div className="flex gap-2" key={record._id}>
                    <ManagerModel
                        key={record._id}
                        id={record._id}
                        submitHandler={handleCountrySubmit}
                        _country={record}
                    />
                    <Button
                        title="Delete"
                        icon={<DeleteOutlined />}
                        onClick={() => handleDeleteSlide(record._id)}
                    ></Button>
                </div>
            ),
        },
    ];

    return (
        <div>
            <div className="flex items-center justify-between mb-4">
                <h1 className="text-xl">Countries</h1>
                <div className="flex gap-2 ml-auto">
                    <DebouncedSearch
                        onSearch={handleSearch}
                        placeholder="Search Countries..."
                    />
                    <ManagerModel submitHandler={handleCountrySubmit} />
                </div>
            </div>
            <CommonTable
                data={Country.records}
                columns={columns}
                loading={Country.loading}
                pagination={pagination}
                onChange={onChangeTable}
            />
        </div>
    );
}

function ManagerModel({ id, _country, submitHandler }) {
    const [open, setOpen] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
        setError,
    } = useForm();

    const onSubmit = (body) => {
        submitHandler(body, id, setOpen);
    };

    return (
        <div className="">
            <Button
                className={!id ? 'float-right mb-2' : ''}
                title={id ? 'Edit' : 'Add'}
                icon={id ? <EditFilled /> : <PlusOutlined />}
                onClick={() => setOpen(true)}
            >
                {id ? '' : 'Add'}
            </Button>

            <Modal
                centered
                title={(id ? 'Edit' : 'Add') + ' Country'}
                open={open}
                onOk={() => setOpen(false)}
                footer={false}
                onCancel={() => setOpen(false)}
            >
                <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-group mb-6">
                            <label className="font-bold">
                                Name <span className="text-red-600">*</span>
                            </label>
                            <span className="text-red-600 md:ml-4">
                                {errors?.name?.message}
                            </span>
                            <input
                                type="text"
                                className={inputClass}
                                name="name"
                                {...register('name', { required: 'field is required' })}
                                aria-describedby="name"
                                placeholder="name"
                                defaultValue={_country?.name || ''}
                            />
                        </div>
                        <div className="form-group mb-6">
                            <label className="font-bold">
                                Title <span className="text-red-600">*</span>
                            </label>
                            <span className="text-red-600 md:ml-4">
                                {errors?.title?.message}
                            </span>
                            <input
                                type="text"
                                className={inputClass}
                                name="title"
                                {...register('title', { required: 'field is required' })}
                                aria-describedby="description"
                                placeholder="title"
                                defaultValue={_country?.title || ''}
                            />
                        </div>
                        <div className="form-group mb-6">
                            <label className="font-bold">
                                Description <span className="text-red-600">*</span>
                            </label>
                            <span className="text-red-600 md:ml-4">
                                {errors?.description?.message}
                            </span>
                            <textarea
                                type="text"
                                className={inputClass}
                                name="description"
                                {...register('description', {
                                    required: 'field is required',
                                })}
                                aria-describedby="description"
                                placeholder="description"
                                defaultValue={_country?.description || ''}
                            />
                        </div>
                        <div className="form-group mb-6">
                            <label className="font-bold">Num Code</label>
                            <input
                                type="text"
                                className={inputClass}
                                name="num_code"
                                aria-describedby="num_code"
                                placeholder="num code"
                                defaultValue={_country?.num_code || ''}
                            />
                        </div>
                        <div className="form-group mb-6">
                            <label className="font-bold">Str Code</label>
                            <input
                                type="text"
                                className={inputClass}
                                name="str_code"
                                aria-describedby="str_code"
                                placeholder="str code"
                                defaultValue={_country?.str_code || ''}
                            />
                        </div>
                        <div>
                            <button
                                type="submit"
                                className="px-4 py-2 rounded shadow hover:bg-gray-200"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>
        </div>
    );
}
